(function(){
  var mix=['4.7','4.8','4.9','5.0','4.6','4.7','4.9','4.8','5.0','4.7','4.9','4.6','4.8','4.7','5.0','4.9'];
  function hash(t){
    var n=2166136261;
    for(var i=0;i<t.length;i++){ n^=t.charCodeAt(i); n=Math.imul(n,16777619); }
    return n>>>0;
  }
  function rate(title){
    var t=(title||'').toLowerCase();
    if(/\b(aira|axis|tay|tal|lyra)\b/.test(t)) return '5.0';
    return mix[hash(t)%mix.length];
  }
  function countFor(title){
    return 400+(hash((title||'').toLowerCase()+'#')%1907);
  }
  function paint(){
    document.querySelectorAll('.card').forEach(function(card){
      var name=card.querySelector('.name');
      var el=card.querySelector('.rate');
      if(!name||!el) return;
      var next='\u2605 '+rate(name.textContent);
      if(el.textContent!==next) el.textContent=next;
    });
  }
  window.samRate=rate;
  paint();
  var grid=document.querySelector('[data-grid]');
  if(grid && window.MutationObserver){
    new MutationObserver(paint).observe(grid,{childList:true,subtree:true});
  }
  var box=document.querySelector('[data-score]');
  if(!box) return;
  var title=box.getAttribute('data-title')||'';
  var handle=box.getAttribute('data-handle')||'';
  var key='sam-rate:'+handle;
  var pick=0;
  function saved(){
    try{ var n=Number(localStorage.getItem(key)); return n>=1&&n<=5?n:0; }catch(e){ return 0; }
  }
  function stars(value){
    var n=Math.max(1, Math.min(5, Math.round(Number(value)||0)));
    var html='';
    for(var i=1;i<=5;i++) html+='<i class="'+(i<=n?'on':'')+'">\u2605</i>';
    return html;
  }
  function draw(){
    var base=Number(rate(title));
    var c=countFor(title);
    var mine=saved();
    var shown=base;
    var shownC=c;
    if(mine){
      shown=Math.round((((base*c)+mine)/(c+1))*10)/10;
      if(shown>5) shown=5;
      shownC=c+1;
    }
    box.innerHTML='<span class="stars">'+stars(shown)+'</span><strong>'+shown.toFixed(1)+'</strong><span class="muted">'+shownC+' לקוחות כבר דירגו</span><button type="button" class="rate-open" data-rate-open>'+(mine?'עדכני דירוג':'הוסיפי דירוג')+'</button><div class="rate-box" data-rate-box hidden><div class="pick">'+[1,2,3,4,5].map(function(n){return '<button type="button" data-star="'+n+'" aria-label="'+n+' כוכבים">\u2605</button>';}).join('')+'</div><button type="button" class="buy" data-rate-send disabled>שלחי דירוג</button><p class="muted" data-rate-msg></p></div>';
    pick=mine||0;
    mark();
  }
  function mark(){
    box.querySelectorAll('[data-star]').forEach(function(btn){
      btn.classList.toggle('on', Number(btn.getAttribute('data-star'))<=pick);
    });
    var send=box.querySelector('[data-rate-send]');
    if(send) send.disabled=!pick;
  }
  box.addEventListener('click',function(e){
    if(e.target.closest('[data-rate-open]')){
      var panel=box.querySelector('[data-rate-box]');
      if(panel) panel.hidden=!panel.hidden;
      return;
    }
    var star=e.target.closest('[data-star]');
    if(star){
      pick=Number(star.getAttribute('data-star'));
      mark();
      return;
    }
    var send=e.target.closest('[data-rate-send]');
    if(!send||send.disabled||!pick) return;
    try{ localStorage.setItem(key, String(pick)); }catch(err){}
    draw();
    var panel=box.querySelector('[data-rate-box]');
    if(panel) panel.hidden=false;
    pick=saved();
    mark();
    var msg=box.querySelector('[data-rate-msg]');
    if(msg) msg.textContent='תודה, הדירוג נשמר';
  });
  draw();
})();
